<template>
    <header v-if="nomeEmpresa == 'GENIAL' || nomeEmpresa == 'RJI' || nomeEmpresa == 'ACTUAL'"
        :class="{ siteHeader: nomeEmpresa == 'GENIAL', siteHeaderActual: nomeEmpresa == 'ACTUAL', siteHeaderRJI: nomeEmpresa == 'RJI' }">
        <div class="logo" v-if="nomeEmpresa == 'GENIAL'">
            <img src="@/assets/logogenial.png" class="logo-image" />
        </div>
        <div class="logo-rji" v-if="nomeEmpresa == 'RJI'">
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" class="logo-image-rji" />
        </div>
        <div v-if="nomeEmpresa == 'ACTUAL'">
            <img src="@/assets/logoActual_v2.png" style="display:none;" class="logo-image-actual" />
        </div>
        <nav class="navigation" style="z-index: 1; position: relative;">
            <ul>
                <li style="height: 42px;">
                    <!-- <button type="button" @click="irParaCadastroPF" class="submit-button-login">Cadastro</button> -->
                </li>
            </ul>
        </nav>
    </header>
    <header class="site-header" v-if="nomeEmpresa != 'GENIAL' && nomeEmpresa != 'RJI' && nomeEmpresa != 'ACTUAL'">
        <div class="logo">
        </div>
        <nav class="navigation">
            <ul>
                <li><button type="button" @click="irParaCadastroPF" class="submit-button-login">Cadastro</button></li>
            </ul>
        </nav>
    </header>
    <div class="container"
        :class="{ containerGenial: nomeEmpresa == 'GENIAL', containerActual: nomeEmpresa == 'ACTUAL', containerRJI: nomeEmpresa == 'RJI' }">
        <div v-if="!openToken" class="header">
            <div class="logo">
                <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH'" style="width: 100%; height: 100%;"/>
                <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;" />
                <img src="@/assets/logoLastro.jpg" v-if="nomeEmpresa == 'Lastro'" style="width: 100%; height: 100%;" />

            </div>
            <h2>Selecione o tipo de conta</h2>
        </div>
        <div v-if="openToken" class="header">

            <p style="cursor: pointer; margin-top: 10px; align-self: flex-start; cursor: pointer; display: inline-flex;"
                @click="voltar()"><img src="@/assets/arrow.svg" /> Voltar</p>

            <div>
                <img src="@/assets/cadeado_com_fundo.svg" />
            </div>
            <h2 style="color: #00235C; font-size: 30px;">Chave de acesso</h2>
        </div>
        <div class="tabs-container" v-if="!openToken">
            <div class="tab-item" v-if="verificarTipoCliente('1')" :class="{ active: tab === 1 }">
                <a href="javascript:;" class="link" @click="selectTab(1)">
                    PESSOA FÍSICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('2')" :class="{ active: tab === 2 }">
                <a href="javascript:;" class="link" @click="selectTab(2)">
                    PESSOA JURÍDICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('3')" :class="{ active: tab === 3 }">
                <a href="javascript:;" class="link" @click="selectTab(3)">
                    FUNDOS
                </a>
                <div class="underline"></div>
            </div>
        </div>
        <div class="header" style="margin-top: 0; padding-top: 20px;">
            <p v-if="!openToken && nomeEmpresa != 'GENIAL'" style="margin-top: 0;">Bem-vindo de volta! Por favor, insira
                seus dados.</p>
            <p v-if="!openToken && nomeEmpresa == 'GENIAL'" style="margin-top: 0;">Bem-vindo! Por favor, insira seus
                dados.</p>
            <p v-if="openToken" style="margin-top: 0;">Para continuar, digite o código que acabamos de enviar para o seu
                e-mail.</p>
        </div>
        <form v-if="tab === 1 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <div class="input-field">
                <label for="email">E-mail ou CPF</label>
                <input type="text" v-model="loginSession.Usuario" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" ref="emailField1" />
            </div>
            <div class="input-field">
                <label for="password">Senha</label>
                <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                <p class="erro" style="max-width: 360px; display: flex;">{{ messageError }}</p>
            </div>
            <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
            <router-link class="forgot-password" to="/RecuperarSenha">Esqueci minha senha</router-link>
            <button type="submit" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                class="submit-button-login">
                <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                <div class="loadingDots" v-if="disableBtnLogin">
                    <span class="dot">.</span>
                    <span class="dot2">.</span>
                    <span class="dot3">.</span>
                </div>
            </button>
        </form>
        <form v-if="tab === 2 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <fieldset :disabled="loading" style="border: none">
                <div class="input-field">
                    <label for="email">E-mail ou CNPJ</label>
                    <input type="text" v-model="loginSession.Usuario" v-if="nomeEmpresa != 'GENIAL'" class="field"
                        autocomplete="off" @click.stop.prevent="clear" @blur="handleEmailBlur"
                        :class="{ erroBorder: erro && nomeEmpresa != 'GENIAL', erroBorderVerifyRegister: erro && nomeEmpresa == 'GENIAL' }"
                        ref="emailField2" />
                    <input type="text" v-model="loginSession.Usuario" v-if="nomeEmpresa == 'GENIAL'" class="field"
                        autocomplete="off" @click.stop.prevent="clear" :class="{ erroBorderVerifyRegister: erro }" />
                </div>
                <div class="input-field" v-if="configuracaoApelido == 'S'">
                    <label for="apelido">Selecione o apelido da conta para logar</label>
                    <select v-model="loginSession.Apelido" class="field" style="margin-bottom: 20px;">
                        <option v-for="apelido in apelidos" :key="apelido" :value="apelido">{{ apelido }}</option>
                    </select>
                </div>
                <div class="input-field" v-if="nomeEmpresa != 'GENIAL'">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                    <p class="erro" style="max-width: 360px; display: flex;">{{ messageError }}</p>
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" v-if="nomeEmpresa != 'GENIAL'" to="/RecuperarSenha">Esqueci minha
                    senha</router-link>
                <button type="submit" v-if="nomeEmpresa != 'GENIAL'" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
                <button type="button" @click="sendLogin()" v-if="nomeEmpresa == 'GENIAL'" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </fieldset>
        </form>
        <form v-if="tab === 3 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <fieldset :disabled="loading" style="border: none">
                <div class="input-field">
                    <label for="email">E-mail ou CNPJ</label>
                    <input type="text" v-model="loginSession.Usuario" class="field" autocomplete="off"
                        @click.stop.prevent="clear" @blur="handleEmailBlur" :class="{ erroBorder: erro }"
                        ref="emailField3" />
                </div>
                <div class="input-field" v-if="configuracaoApelido == 'S'">
                    <label for="apelido">Selecione o apelido da conta para logar</label>
                    <select v-model="loginSession.Apelido" class="field" style="margin-bottom: 20px;">
                        <option v-for="apelido in apelidos" :key="apelido" :value="apelido">{{ apelido }}</option>
                    </select>
                </div>
                <div class="input-field">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                    <p class="erro" style="max-width: 360px; display: flex;">{{ messageError }}</p>
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" to="/RecuperarSenha">Esqueci minha senha</router-link>
                <button type="submit" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                    class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </fieldset>
        </form>
        <form class="form" v-if="openToken" @submit.stop.prevent="sendLoginWithToken">
            <div class="input-field">
                <label for="password">Chave de acesso</label>
                <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                <p class="erro" style="max-width: 360px; display: flex;">{{ messageError }}</p>
            </div>
            <button type="button" @click="sendLoginWithToken()" v-if="nomeEmpresa == 'GENIAL'"
                :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                <div class="loadingDots" v-if="disableBtnLogin">
                    <span class="dot">.</span>
                    <span class="dot2">.</span>
                    <span class="dot3">.</span>
                </div>
            </button>
        </form>
        <div class="footer" v-if="nomeEmpresa != 'GENIAL'">
            <p>Ainda não possui conta? <router-link to="/CadastroInicio">Cadastre-se</router-link></p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api/axios';

export default {
    name: 'UserLogin',
    data() {
        return {
            tab: 1,
            loginSession: {
                Usuario: null,
                Senha: null
            },
            apelidos: [],
            disableBtnLogin: false,
            messageError: null,
            erro: false,
            openToken: false,
            habilitarReenviarEmail: false,
            nomeEmpresa: '',
            loading: false,
            tiposClientes: [],
            configuracaoTiposClientes: {},
            configuracaoURLEntrar: '',
            configuracaoApelido: ''
        };
    },
    computed: {
        ...mapGetters({
            getConfiguracoes: 'GET_CONFIGURACOES',
        })
    },
    mounted() {
        this.disableBtnLogin = false;
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        //Regra especifica para Genial, abrir aba de Pessoa Jurídica
        this.tab = this.nomeEmpresa != 'GENIAL' ? 1 : 2;
    },
    async created() {
        await this.fetchConfiguracao(['Remover tipo de cadastro', 'Redirecionamento do botão entrar Onboarding externo', 'Exibir apelido']);
        this.configuracaoTiposClientes = this.getConfiguracoes('Remover tipo de cadastro');
        this.configuracaoURLEntrar = this.getConfiguracoes('Redirecionamento do botão entrar Onboarding externo').Valor;
        this.configuracaoApelido = this.getConfiguracoes('Exibir apelido').Valor;
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            verifyStatusRegister: 'auth/verifyStatusRegister',
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        voltar() {
            this.loginSession = {
                Usuario: null,
                Senha: null
            };
            this.openToken = false;
        },
        async verificarStatusCadastro() {
            var model = { Usuario: this.loginSession.Usuario }
            await this.verifyStatusRegister(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.data.data == null) {
                        this.$router.push({ name: 'CadastroInicio' });
                    }
                    else if (response.data.data.StatusCadastro == 0) {
                        this.messageError = '';
                        this.erro = false;
                        this.openToken = true;
                    } else if (response.data.data.StatusCadastro == 1
                        || response.data.data.StatusCadastro == 4) {
                        this.messageError = '';
                        this.erro = false;
                        this.disableBtnLogin = false;
                        this.$swal({
                            icon: 'warning',
                            title: 'Cadastro em análise!',
                            text: 'Estamos analisando os dados recebidos. Em breve você receberá novidades no e-mail informado.',
                        });                        
                        return;
                    } else {
                        window.location.href = this.configuracaoURLEntrar;
                    }

                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    if (error.response.data == '') {
                        this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                        this.erro = true;
                    } else if (error.response.data?.data[0] == 'Cliente não validado o e-mail!') {
                        this.messageError = 'Falha na autenticação. Confirme seu endereço de e-mail.';
                        this.erro = true;
                        this.habilitarReenviarEmail = true;
                    } else {
                        this.messageError = error.response.data?.data[0];
                        this.erro = true;
                    }
                });
        },
        verificarTipoCliente(tipo) {
            return this.tiposClientes.some(cliente => Number(cliente.value) === Number(tipo));
        },
        selectTab(index) {
            this.tab = index;
            this.$nextTick(() => {
                if (this.tab === 1) {
                    this.$refs.emailField1.focus();
                } else if (this.tab === 2) {
                    this.$refs.emailField2.focus();
                } else if (this.tab === 3) {
                    this.$refs.emailField3.focus();
                }
            });
        },
        async handleEmailBlur() {
            if (!this.loginSession.Usuario) {
                this.apelidos = [];
                return;
            }
            this.loading = true;
            try {
                if (this.configuracaoApelido == 'S') {
                    const encodedCredentials = btoa('sat@sat:sat23!');
                    const response = await api.get('/login', {
                        params: { chaveLogin: this.loginSession.Usuario, tipoCliente: this.tab },
                        headers: { 'Authorization': `Basic ${encodedCredentials}` }
                    });
                    this.apelidos = response.data.data;
                }
            } catch (error) {
                this.apelidos = null;
                console.error('Erro ao buscar apelidos:', error);
            } finally {
                this.loading = false;
            }
        },
        irParaCadastroPF() {
            this.$router.push({ name: 'CadastroInicio' });
        },
        async reenviarEmail() {
            if (this.loginSession.Usuario == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Email: this.loginSession.Usuario }
            const encodedCredentials = btoa('sat@sat:sat23!');
            await api
                .post('/register/email-ativar-conta', model, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                .then((retorno) => {
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha no envio do e-mail. Verifique as credenciais de acesso.`,
                        });
                    }
                    else {
                        this.habilitarReenviarEmail = false;
                        this.messageError = '';
                        this.erro = false;
                        this.$swal({
                            icon: 'success',
                            title: 'E-mail enviado!',
                            text: 'Acesse o e-mail cadastrado para confirmar seu acesso.',
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({ name: 'UserLogin' });
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        async sendLoginWithToken() {
            this.disableBtnLogin = true;
            var model = { Usuario: this.loginSession.Usuario, Senha: this.loginSession.Senha, Apelido: this.loginSession.Apelido }
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch(() => {
                    this.disableBtnLogin = false;
                    this.erro = true;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O Token informado não é válido! Verifique e tente novamente.`,
                    });

                });
        },
        async sendLogin() {
            this.disableBtnLogin = true;
            this.habilitarReenviarEmail = false;
            if (this.nomeEmpresa == 'GENIAL') {
                const usuario = this.loginSession.Usuario;
                // Regex simples para validar email e CNPJ
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const cnpjRegex = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
                if (!usuario || (!emailRegex.test(usuario) && !cnpjRegex.test(usuario))) {
                    this.messageError = 'Verifique os dados';
                    this.erro = true;
                    this.disableBtnLogin = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O CNPJ/E-mail informado não foi encontrado ou é inválido! Verifique os dados e tente novamente.`,
                    });
                    return;
                }
            }
            if ((this.loginSession.Usuario == '' || this.loginSession.Usuario == null) && this.nomeEmpresa != 'GENIAL') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            } else if ((this.loginSession.Senha == '' || this.loginSession.Senha == null) && this.nomeEmpresa != 'GENIAL') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            }
            if (this.nomeEmpresa == 'GENIAL') {
                this.verificarStatusCadastro();
                return;
            }
            var model = { Usuario: this.loginSession.Usuario, Senha: this.loginSession.Senha, Apelido: this.loginSession.Apelido }
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    if (error.response.data == '') {
                        this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                        this.erro = true;
                    } else if (error.response.data?.data[0] == 'Cliente não validado o e-mail!') {
                        this.messageError = 'Falha na autenticação. Confirme seu endereço de e-mail.';
                        this.erro = true;
                        this.habilitarReenviarEmail = true;
                    } else {
                        this.messageError = error.response.data?.data[0];
                        this.erro = true;
                    }
                });
        },
    },
    watch: {
        configuracaoTiposClientes(newVal) {
            if (newVal && newVal.Valor) {
                // eslint-disable-next-line no-debugger
                debugger
                const valores = newVal.Valor.replace('\r\n', ';').replace(',', ';').split(';').map(item => item.trim()).filter(item => item);
                const todasOpcoes = [
                    { value: '1', label: 'Pessoa Física' },
                    { value: '2', label: 'Pessoa Jurídica' },
                    { value: '3', label: 'Fundo de Investimento' }
                ];
                const tiposFiltrados = todasOpcoes.filter(opcao => !valores.includes(opcao.value));
                if (JSON.stringify(tiposFiltrados) !== JSON.stringify(this.tiposClientes)) {
                    this.tiposClientes = tiposFiltrados;
                }
            } else {
                if (this.tiposClientes.length > 0) {
                    this.tiposClientes = [];
                }
            }
            if (this.tiposClientes.length > 0) {
                this.tab = parseInt(this.tiposClientes[0].value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Estilos globais */
body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    //background-color: #f5f5f5;
}

.logo {
    position: relative;
    display: inline-block;
    /* Garante que a logo seja tratada como um bloco em linha */
}

.logo-image {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    /* Mantém a proporção da imagem */
    display: block;
    position: relative;
    z-index: 1;
}

.logo-image-rji {
    height: auto;
    /* Mantém a proporção da imagem */
    display: block;
    position: relative;
    z-index: 1;
    height: 60% !important;
    width: 60% !important;
}

.logo::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    /* Começa fora do contêiner à esquerda */
    height: 60% !important;
    width: 60% !important;
    background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
    z-index: 2;
    /* Garante que a animação fique acima da imagem */
    animation: shine 3s forwards;
}

.logo-rji {
    position: relative;
    display: inline-block;
    /* Garante que a logo seja tratada como um bloco em linha */
}

.logo-rji::before {
    content: '';
    position: absolute;
    top: -10;
    left: -10%;
    /* Começa fora do contêiner à esquerda */
    height: 40px !important;
    width: 100px !important;
    background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
    z-index: 2;
    /* Garante que a animação fique acima da imagem */
    animation: shine_rji 3s forwards;
}

.logo-image-actual {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    /* Mantém a proporção da imagem */
    display: block;
    position: relative;
    z-index: 1;
}

@keyframes shine {
    0% {
        left: -100%;
    }

    100% {
        left: 100%;
    }
}

@keyframes shine_rji {
    0% {
        left: -100%;
    }

    100% {
        left: 50%;
    }
}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    /* Ajuste conforme necessário */
    background-color: #fff;
    /* Ou qualquer cor de fundo que você deseja */
}

.siteHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    /* Ajuste conforme necessário */
    background-color: rgba(255, 255, 255, 0.5) !important;
}

.siteHeaderRJI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    /* Ajuste conforme necessário */
    background-color: rgba(15, 37, 71, 0.5) !important;
}

.siteHeaderActual {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo img {
    height: 32px;
    /* Ajuste conforme o tamanho desejado para o logo */
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
    /* Espaço entre os itens de navegação */
}

.submit-button-login {
    width: 100%;
    padding: 0.5rem;
    color: white;
    border: none;
    cursor: pointer;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
}

.navigation li {
    padding: 0.5rem 1rem;
    /* Ajuste conforme necessário */
}

.navigation a {
    text-decoration: none;
    color: #000;
    /* Cor do texto */
}

.navigation a.router-link-active {
    color: #00235C;
    /* Cor quando o link está ativo */
}

.buttonReenviarEmail {
    cursor: pointer;
    margin-bottom: 10px;
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
    background-color: #00235C;
    /* Cor de fundo para o botão de cadastro */
    color: #fff;
    border-radius: 5px;
    /* Raio da borda para fazer os cantos arredondados */
    padding: 0.5rem 1rem;
}

/* Estilos para o container do login */
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.containerGenial {
    background-color: rgba(255, 255, 255, 0.5) !important;
    height: 100vh;
    width: 30vw;
    /* Define a largura como 50% da viewport */
    position: absolute;
    /* Garante que a div ocupe a área da viewport */
    top: 0;
    right: 0;
    /* Posiciona a div no lado direito */
}

.containerActual {
    background-color: rgba(37, 36, 87, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    /* Define a largura como 50% da viewport */
    position: absolute;
    /* Garante que a div ocupe a área da viewport */
    top: 0;
    right: 0;
    /* Posiciona a div no lado direito */
}

.containerRJI {
    background-color: rgba(15, 37, 71, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    /* Define a largura como 50% da viewport */
    position: absolute;
    /* Garante que a div ocupe a área da viewport */
    top: 0;
    right: 0;
    /* Posiciona a div no lado direito */
}

.containerRJI h2 {
    color: #FFF !important;
}

.containerRJI p {
    color: #FFF !important;
}

.containerRJI label {
    color: #FFF !important;
}

.containerRJI a {
    color: #FFF !important;
    font-weight: 800;
}

.containerActual h2 {
    color: #FFF !important;
}

.containerActual p {
    color: #FFF !important;
}

.containerActual label {
    color: #FFF !important;
}

.containerActual a {
    color: #FFF !important;
    font-weight: 800;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.header h2 {
    width: 360px;
    /* Largura do elemento */
    height: 38px;
    /* Altura do elemento */
    font-family: 'Gabarito', sans-serif;
    /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
    font-weight: 600;
    /* Peso da fonte semibold */
    font-size: 30px;
    /* Tamanho da fonte */
    line-height: 38px;
    /* Altura da linha */
    text-align: center;
    /* Alinhamento do texto ao centro */
    margin: 0 auto;
    /* Margem automática nas laterais para centralizar caso o elemento pai seja maior que 360px */
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 400;
    /* Peso normal da fonte */
    font-size: 16px;
    /* Tamanho da fonte */
    line-height: 24px;
    /* Altura da linha */
    text-align: center;
    /* Alinhamento do texto ao centro */
    color: #6E6E6E;
    /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    /* Este é um cinza genérico, ajuste conforme necessário */
    font-size: 16px;
    /* Exemplo de tamanho de fonte, ajuste conforme necessário */
    line-height: 24px;
    /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
    font-weight: 600;
    /* Para 'Cadastre-se', que parece ser mais destacado */
    color: #101828;
    /* Este é o azul padrão de links, ajuste conforme necessário */
    text-decoration: none;
    /* Para sublinhar o link */
}

/* Aplicando estilos de fonte */
button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    /* Ajuste para a linha de altura */
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Arredondamento dos inputs */
    box-sizing: border-box;
    /* Garante que o padding não adicione largura extra */
    width: 100%;
    /* Para garantir que os inputs ocupem toda a largura do container */
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erroBorderVerifyRegister {
    border: 1px solid #E73D3D !important;
    margin-bottom: 10px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
    max-width: 360px;
}

/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 500;
    /* Peso médio da fonte */
    font-size: 14px;
    /* Tamanho da fonte */
    line-height: 20px;
    /* Altura da linha */
    color: #344054;
    /* Cor do texto em cinza escuro */
}

/* Estilos para o formulário */
form {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    width: calc(130px * 3 + 40px * 2);
}

/* Estilos para os inputs */
input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

/* Botão de entrar */
button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

/* Media query para telas menores */
@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}

.tabs-container {
    display: flex;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #D3D3D3;
}

.tab-item {
    position: relative;
    min-width: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-left: 20px;
}

.tab-item .link {
    display: inline-block;
    padding: 10px;
    color: rgb(1, 1, 68);
    text-decoration: none;
    margin-left: 18px;
    font-weight: bold;
}

.tab-item .underline {
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: transparent;
    transition: background-color 0.3s;
}

.tab-item.active .link {
    color: rgb(1, 1, 68);
}

.tab-item.active .underline {
    background-color: rgb(1, 1, 68);
    margin-left: -18px;
}
</style>
